import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';
import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { EmergencyNotificationConfigurationFormController } from '../EmergencyNotificationConfigurationForm.types';

import { EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable } from './responseTeamPractitioners/EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable';

type EmergencyNotificationInAppConfigurationResponseTeamPractitionersFieldProps = Pick<
   EmergencyNotificationConfigurationFormController,
   'register'
> & {
   readonly practitioners: PractitionerView[];
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
};

export const EmergencyNotificationInAppConfigurationResponseTeamPractitionersField = (
   props: EmergencyNotificationInAppConfigurationResponseTeamPractitionersFieldProps
): JSX.Element => {
   return (
      <EmergencyNotificationInAppConfigurationResponseTeamPractitionersInteractiveTable
         register={props.register}
         practitioners={props.practitioners}
         emergencyNotificationConfiguration={props.emergencyNotificationConfiguration}
      />
   );
};
